import React, { useEffect, useState, useRef } from 'react';

import ProductCategoryView from '../../views/AdminView/ProductCategoryView';
import { getAllProductCategories, createProductCategory ,updateProductCategory,deleteProductCategoryById} from '../../services/api'; // Named Export

const ProductCategoryComponent = () => {

    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);
    const [productCategoryObj, setProductCategory] = useState([]);

    const handleProductAddOrUpdate = async (productCategory) => {
        setLoading(true);
        if (productCategory.id !== undefined && productCategory.id > 0) {
            const response = await updateProductCategory(productCategory);
            setProductCategory(response.data);
              setLoading(false);
            return response; 
        } else {
            const response = await createProductCategory(productCategory);
            setProductCategory(response.data);
              setLoading(false);
            return response; 
        }
      
     
    };
    const deleteProductCategory = async (id) => {
        setLoading(true);
        try {
            const response = await deleteProductCategoryById(id);       
            setProductCategory(response.data);
            setLoading(false);
            return response; // Return the response for further handling if needed
        } catch (error) {
            console.error('Error deleting product category:', error);
            setLoading(false);
            return { status: 500, message: 'Failed to delete product category.' }; // Return an error response

        }
    };
       const getData = async () => {

        try {
            const response = await getAllProductCategories();
            setProductCategory(response.data);
            setLoading(false);


        } catch (error) {
            console.error('Error fetching data:', error);
            error.current = 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });
    return <div>
        {!loading && productCategoryObj != null && <ProductCategoryView productCategory={productCategoryObj}
            onAddOrUpdate={handleProductAddOrUpdate} onDeleteProductCategory={deleteProductCategory} />}
    </div>

};

export default ProductCategoryComponent;
